import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import {
  textMatcher,
  cellRenderer,
  amountComparator,
} from '../../../../SharedModules/utilities/utilities';

export const ResultTableHead = [
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: true,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_100,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug name',
    field: 'drugName',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_300,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Unit Invoiced',
    field: 'noOfUnits',
    editable: false,
    suppressMenu: false,
    sortable: true,
    excelAlignment: 'right',
    minWidth: Styles.Width_180,
    cellRenderer: cellRenderer,
    comparator: amountComparator,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Paid Amount',
    field: 'paidAmt',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_180,
    cellRenderer: cellRenderer,
    comparator: amountComparator,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher,
    },
    printPrefixValue: '$',
    isTextColorRed: true,
  },
];
